export default "__VITE_ASSET__5cc3692f__"